import {$window, $body} from '../../../Constants';
import HtmlElement from '../../../Elements/HtmlElement';

/**
 * Anchor Navigation
 */
const AnchorNavigation = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		ANCHOR_NAVIGATION: '.anchor-navigation',
	};

	/**
	 * Anchor Navigation
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class AnchorNavigation extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this._isScrolled = false;
			this._checkScrolled();
			this._initializeSections();

			$window.on('scroll', () => {
				this._checkScrolled();
			});
		}

		_checkScrolled() {
			if (!this._isScrolled && $window.scrollTop() >= 300) {
				this.$element.addClass('scrolled');
				this._isScrolled = true;
			} else if (this._isScrolled && $window.scrollTop() < 300) {
				this.$element.removeClass('scrolled');
				this._isScrolled = false;
			}
		}

		_initializeSections() {
			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this._activateSection(entry.target.dataset.section);
					} else {
						this._deactivateSection(entry.target.dataset.section);
					}
				});
			}, {
				threshold: 0.5
			});

			document.body.querySelectorAll('[data-section]').forEach((section) => {
				observer.observe(section);
			});
		}

		_getSectionItem(section) {
			return this.$element.find(`a[data-section="${section}"]`);
		}

		_activateSection(section) {
			const $sectionItem = this._getSectionItem(section);
			$sectionItem.addClass('active');
			this._deactivateAllOtherSections($sectionItem);
		}

		_deactivateSection(section) {
			const $sectionItem = this._getSectionItem(section);
			$sectionItem.removeClass('active');
		}

		_deactivateAllOtherSections($sectionItem) {
			this.$element.find('a').not($sectionItem).removeClass('active');
		}
	}

	return AnchorNavigation._getElement($body.find(Selector.ANCHOR_NAVIGATION), AnchorNavigation);
})();

export default AnchorNavigation;
